/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { useErrorBoundary } from 'preact/hooks';

// Core
import RouterComponent from '@client/services/router/components/router';
import { Button, Popover, Link, Input } from '@client/components';

// App
import { FiltersProvider } from '../domains/Filters';
import Analytics from '@/client/services/metrics/Component';

// Resources
import './index.less';
import Logo from '@/client/assets/identity/logo-dark.png';
import LoaderComponent from './Loader';
import sectorIcons from '../domains/Filters/sectorIcons';

/*----------------------------------
- TYPES
----------------------------------*/

/*----------------------------------
- LAYOUT
----------------------------------*/

// TODO: Route.layout()
// TODO: route.config.bodyClass
export const data = ({ api }) => ({
    stats: api.get('/stats/general'),
    navigation: api.get('/ui/navigation'),
})

export default ({ data, user, api, Router, toast, modal, context, app, request, page }) => {

    /*----------------------------------
    - INIT
    ----------------------------------*/

    // Render bug report
    // TIDO: move to framework
    useErrorBoundary(e => {
        app.reportBug({
            before: 'Render page',
            stacktrace: e.stack
        }).then(() => {

            // Reload page
            if (__DEV__) {
                console.warn(`The app would be reloaded in production mode.`);
                toast.error(`Errur during page rendering: ${e.message}`);
                console.error(e);
            } else 
                toast.error(`An issue occurred while loading this page. Our dev team will solve it asap.`);
        })
    });

    const searchInput = React.useRef();

    const [openMenu, setOpenMenu] = React.useState<boolean>(false);
    const [openSectors, setOpenSectors] = React.useState<boolean>(false);
    const [openSearchPrompt, setOpenSearchPrompt] = React.useState<boolean>(false);
    context.setOpenMenu = setOpenMenu;

    // On page change, close menus
    React.useEffect(() => {
        return Router.on('page.changed', () => {
            setOpenMenu(null);
        });
    }, []);

    React.useEffect(() => {

        if (openSearchPrompt)
            searchInput.current?.focus();

    }, [openSearchPrompt])

    /*----------------------------------
    - ACTIONS
    ----------------------------------*/ 
    
    const logout = () => api.post('/auth/logout').then(() => {
        context.user = null;
        app.Router.go('/');
    })

    const openHelp = () => modal.show(({ close }) => (
        <div class="card col w-3">

            <Button icon="times" shape="pill" size="s" class="close" 
                onClick={() => close(true)} />

            <header class="col al-center">
                <h2>Do you need help?</h2>
                <p class="txt-left">
                    On which channel do you want to reach me out?
                </p>
            </header>

            <div class="col menu">
                <Button icon="brands/whatsapp" link="https://wa.me/33601711555">
                    Whatsapp (best)
                </Button>
                <Button icon="brands/linkedin" link="https://www.linkedin.com/in/gaetanlegac/">
                    LinkedIn
                </Button>
                <Button icon="at" link="mailto:contact@gaetan-legac.fr">
                    Email
                </Button>
            </div>

        </div>
    ))
    context.openHelp = openHelp;

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    return <>

        <Analytics />

        <div id="layout" class="platform col al-center al-top">

            <div id="contPage" class="col row-1">

                <FiltersProvider>
                    <RouterComponent service={Router} loaderComponent={LoaderComponent} />
                </FiltersProvider>

            </div>

            <Button icon="comment-alt" type="primary" shape="pill" size="l"
                hint="Get help"
                onClick={openHelp} style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    zIndex: 1000,
                }} />
        </div>
    </>
}